import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfterSection() {
  const without = ['Me despierto a las 3 AM', 'Niebla mental todo el día', 'Dependo de pastillas', 'Me levanto agotado', 'Mal humor en las mañanas'];
  const withProtocol = ['Duermo hasta que sale el sol', 'Claridad mental y energía', 'Sueño 100% natural', 'Me levanto renovado', 'Amanezco de buen humor'];
  return <section className="py-20 md:py-24 bg-[#0d1527]" data-id="element-74">
      <div className="max-w-5xl mx-auto px-6" data-id="element-75">
        <FadeIn data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-4 text-glow" data-id="element-77">
            La diferencia que verás desde la primera noche
          </h2>
          <p className="text-center text-cream-muted text-body-lg mb-14 max-w-2xl mx-auto" data-id="element-78">
            Compara cómo te sientes hoy con cómo te sentirás aplicando el
            protocolo.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-79">
          <FadeIn delay={0.1} data-id="element-80">
            <div className="card-glass rounded-md p-8 h-full" data-id="element-81">
              <h3 className="text-2xl font-serif mb-6 text-center text-cream-muted" data-id="element-82">
                Sin el Protocolo
              </h3>
              <ul className="space-y-5" data-id="element-83">
                {without.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-84">
                    <span className="w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-85">
                      <XIcon className="w-4 h-4 text-red-300" data-id="element-86" />
                    </span>
                    <span className="text-cream-muted leading-relaxed" data-id="element-87">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-88">
            <div className="card-glass rounded-md p-8 h-full border-gold-500/40 box-glow" style={{
            borderColor: 'rgba(201,168,76,0.4)'
          }} data-id="element-89">
              <h3 className="text-2xl font-serif mb-6 text-center text-gold-400" data-id="element-90">
                Con el Protocolo
              </h3>
              <ul className="space-y-5" data-id="element-91">
                {withProtocol.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-92">
                    <span className="w-7 h-7 rounded-full bg-green-400/25 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-93">
                      <CheckIcon className="w-4 h-4 text-green-200" data-id="element-94" />
                    </span>
                    <span className="text-white leading-relaxed" data-id="element-95">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}